module.exports = __webpack_public_path__ + "media/assets/icons/tep-logo-bf71d5d3273dcc8cce23abacb7203aba.png";